import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import Table from '@cloudscape-design/components/table';
import Header from '@cloudscape-design/components/header';
import Box from '@cloudscape-design/components/box';
import Link from '@cloudscape-design/components/link';
import { listViews } from '../api/stores';
import { getCredentials } from '../api/client';

export function ViewList() {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({
    queryKey: ['views'],
    queryFn: () => listViews(),
    enabled: !!getCredentials(),
  });

  const views = ((data?.data as any)?.views) || [];

  return (
    <div>
      <Header variant="h1">Views ({views.length})</Header>
      <Table
        loading={isLoading}
        loadingText="Loading views"
        items={views}
        trackBy="storeName"
        columnDefinitions={[
          {
            id: 'name',
            header: 'Name',
            cell: (item: any) => (
              <Link href={`/views/${item.storeName}`} onFollow={(e) => { e.preventDefault(); navigate(`/views/${item.storeName}`); }}>
                {item.storeName}
              </Link>
            ),
          },
          { id: 'sources', header: 'Sources', cell: (item: any) => {
            const sources: string[] = item.sources || [];
            if (sources.length === 0) return '-';
            return sources.map((s, i) => (
              <React.Fragment key={s}>
                {i > 0 && ', '}
                <Link href={`/stores/${s}`} onFollow={(e) => { e.preventDefault(); navigate(`/stores/${s}`); }}>
                  {s}
                </Link>
              </React.Fragment>
            ));
          } },
          { id: 'correlationKey', header: 'Correlation Key', cell: (item: any) => item.correlationKey || '-' },
          { id: 'status', header: 'Status', cell: (item: any) => item.status || '-' },
        ]}
        empty={<Box textAlign="center">No views created yet.</Box>}
      />
    </div>
  );
}
